import React, { useEffect, useState } from 'react';
import { ToastMessage } from './types';

interface ToastItemProps {
    toast: ToastMessage;
    onRemove: (id: string) => void;
}

const ToastItem: React.FC<ToastItemProps> = ({ toast, onRemove }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // 如果设置了持续时间，则到期后自动关闭
        // 如果没有关闭按钮，这是唯一的自动关闭方式
        if (toast.duration) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                // 动画结束后再移除
                setTimeout(() => onRemove(toast.id), 300); // 假设 300ms 是退场动画时间
            }, toast.duration);
            return () => clearTimeout(timer);
        }
        return () => {}
        // 如果没有 duration，并且没有关闭按钮，toast 将一直显示，除非手动通过 onRemove 移除
        // 这是一个潜在的问题，如果 toast.duration 未定义，它将不会自动消失
    }, [toast, onRemove]);

    // 移除了 handleClose 方法，因为按钮被移除了

    if (!isVisible) return null;

    // 基本样式，请根据您的 UI 库或设计进行调整
    const baseStyle: React.CSSProperties = {
        padding: '10px 15px',
        margin: '10px', // 这个 margin 可能会影响父容器的居中，如果需要 ToastItem 紧密排列或由父容器完全控制间距，可以考虑移除或调整
        borderRadius: '4px',
        color: 'white',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'center', // 修改为 center 使内容居中
        alignItems: 'center',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
    };

    const typeStyles: Record<string, React.CSSProperties> = {
        success: { backgroundColor: 'green' },
        error: { backgroundColor: 'red' },
        warning: { backgroundColor: 'orange' },
        info: { backgroundColor: 'blue' },
    };

    return (
        <div style={{ ...baseStyle, ...typeStyles[toast.type] }}>
            <span>{toast.message}</span>
            {/* 关闭按钮已被移除 */}
        </div>
    );
};

export default ToastItem;
